import { Directive, ElementRef, EventEmitter, inject, Output } from '@angular/core';

@Directive({
  selector: '[clickOutside]',
  host: {
    '(window:click)': 'onClick($event)'
  }
})
export class ClickOutsideDirective {
  @Output() readonly clickOutside = new EventEmitter<MouseEvent>();

  private readonly hostElementRef = inject(ElementRef<HTMLElement>);

  onClick(event: MouseEvent): void {
    if (this.clickedHostOrAnyOfItsChildren(event.target as HTMLElement)) {
      return;
    }

    this.clickOutside.emit(event);
  }

  private clickedHostOrAnyOfItsChildren(clicked: HTMLElement): boolean {
    const hostElement = this.hostElementRef.nativeElement;

    let current = clicked;

    while (current) {
      if (current === hostElement) {
        return true;
      }
      current = current.parentElement as HTMLElement;
    }

    return false;
  }
}